
    
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AttendCourtAppearanceInstructions extends Vue {    

    @Prop({required: true})
    instructionsStep!: string;

    @Prop({required: true})
    byConsent!: boolean;

    @Prop({required: true})
    writtenResponse!: boolean;
    
}
